import { EMPTY_OBJECT } from '../../../constants/common'
import { EntityEditFormModal } from '../../Entity'

import { getUserEditTextFieldFormModalValidationSchema } from './UserEditTextFieldFormModal.utils'
import { UserEditTextFieldFormModalFields } from './UserEditTextFieldFormModalFields'

function UserEditTextFieldFormModal({
  Fields = UserEditTextFieldFormModalFields,
  fieldInfoKey,
  fieldLabelKey,
  fieldMaxLength,
  fieldName,
  fieldPlaceholderKey,
  fieldRequired = false,
  formFieldsProps = EMPTY_OBJECT,
  initialValues,
  ...restProps
}) {
  const validationSchema = getUserEditTextFieldFormModalValidationSchema({
    fieldName,
    fieldRequired,
    initialValues,
  })

  function getPayload(values) {
    return {
      [fieldName]: values[fieldName] || null,
    }
  }

  return (
    <EntityEditFormModal
      {...restProps}
      Fields={Fields}
      formFieldsProps={{
        ...formFieldsProps,
        fieldInfoKey,
        fieldLabelKey,
        fieldMaxLength,
        fieldName,
        fieldPlaceholderKey,
        fieldRequired,
      }}
      getPayload={getPayload}
      initialValues={initialValues}
      validationSchema={validationSchema}
    />
  )
}

export default UserEditTextFieldFormModal
